import * as Firebase from 'firebase/app'

import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/performance'
import 'firebase/storage'

import i18n from '@/i18n'

const firebaseConfig = {
    apiKey: "AIzaSyBPW0_qcX0F7__HxAGI9NOuJeAaMpcqHFM",
    authDomain: "oubey-explorer.firebaseapp.com",
    databaseURL: "https://oubey-explorer.firebaseio.com",
    projectId: "oubey-explorer",
    storageBucket: "oubey-explorer.appspot.com",
    messagingSenderId: "219565491920",
    appId: "1:219565491920:web:7ad1ff4f29861a2ba840d5",
    measurementId: "G-JMCVRN0J71"
}

export { Firebase }
export const initializeApp = Firebase.initializeApp( firebaseConfig )

export const initializeFirestore = () => {
    return new Promise( ( resolve, reject ) => {
        Firebase.firestore().enablePersistence( {
            experimentalForceOwningTab: true
        } )
        .then( resolve )
        .catch( error => {
            if ( error.code === 'failed-precondition' ) {
                reject( error )
            } else if ( error.code === 'unimplemented' ) {
                reject( error )
            }
        })
    })
}

export const sendSignInLink = ( email: string ) => {
    const actionCodeSettings = {
        url: `${location.origin}/${i18n.locale}/welcome`,
        handleCodeInApp: true,
        lang: i18n.locale
    }

    return Firebase.auth().sendSignInLinkToEmail( email, actionCodeSettings )
}

export const authService = Firebase.auth()
export const dataService = Firebase.firestore
export const performanceService = Firebase.performance()
